import React, { useState } from 'react';
import FontAwesomeIcon from 'src/components/Icon';
import './CopyButton.scss';

interface CopyButtonProps {
  onCopy: () => void;
}

const CopyButton = ({ onCopy }: CopyButtonProps) => {
  const [copied, setCopied] = useState<boolean>(false);

  const handleClick = () => {
    onCopy();
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2000);
  };

  const label: string = copied ? 'Copied' : 'Copy';
  const icon: React.ReactNode = copied ? (
    <FontAwesomeIcon glyph="check" weight="light" />
  ) : null;

  return (
    <button type="button" className="copy-button" onClick={handleClick}>
      {icon}
      {label}
    </button>
  );
};

export default CopyButton;